import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { FertilizerProductId } from 'services/fertilizerProducts/types';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductName } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
}

type Props = OwnProps;

export default function ProductNameTableCell(props: Props): React.ReactElement {
    const productName = useSelector((state: AppState) =>
        makeSelectProductName()(state, props)
    );

    return <TableCell>{productName}</TableCell>;
}
